import { Check } from "lucide-react";
import AnimateIn from "../ui/AnimateIn";
import SignInLegalNote from "./SignInLegalNote";

const PLAN_FEATURES = [
  "1 month free, then $5 a month",
  "The whole product, including voice",
  "Panoramic board and calendar",
  "Google Calendar sync",
  "Gmail",
  "Lists, tags, and filters",
  "Repeating tasks and sub-tasks",
  "Works offline",
];

interface PricingSectionProps {
  onSignIn: () => void;
  isLoading: boolean;
}

export default function PricingSection({
  onSignIn,
  isLoading,
}: PricingSectionProps) {
  return (
    <section id="pricing" className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6">
        <AnimateIn>
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl text-warm-text-primary mb-4">
              $5 a month
            </h2>
            <p className="text-warm-text-secondary text-lg">
              1 month free, then $5 a month.
            </p>
          </div>
        </AnimateIn>

        <AnimateIn>
          <div className="bg-warm-bg-card border border-warm-border rounded-2xl p-8 max-w-md mx-auto flex flex-col">
            <h3 className="font-display text-xl text-warm-text-primary mb-1">
              Monthly
            </h3>
            <div className="mb-8">
              <span className="text-4xl font-display text-warm-text-primary">
                $5
              </span>
              <span className="text-warm-text-tertiary ml-1">/month</span>
            </div>
            <ul className="space-y-3 flex-1">
              {PLAN_FEATURES.map((feature) => (
                <li
                  key={feature}
                  className="flex items-start gap-2.5 text-sm text-warm-text-secondary"
                >
                  <Check className="w-4 h-4 text-warm-blue shrink-0 mt-0.5" />
                  {feature}
                </li>
              ))}
            </ul>
            <button
              onClick={onSignIn}
              disabled={isLoading}
              className="mt-8 w-full py-3 rounded-soft bg-warm-blue text-white font-medium hover:bg-warm-blue-dark transition-colors text-sm disabled:opacity-50"
            >
              Start 1 month free
            </button>
          </div>
        </AnimateIn>
        <SignInLegalNote className="mt-6 text-center" />
      </div>
    </section>
  );
}
